import NavList from '../NavList';

type TNavSidebarContent = {
  onClose: (value: boolean) => void;
};

const NavSidebarContent = ({ onClose }: TNavSidebarContent) => {
  return (
    <div className='flex flex-1 min-h-0 flex-col'>
      <div className='space-y-2 py-6 pb-24'>
        <NavList
          onClose={onClose}
          className='flex flex-1 flex-col items-start gap-y-1.5 px-2 [&>li]:w-full [&>li>a]:-mx-2 [&>li>a]:block [&>li>a]:rounded-lg
            [&>li>a]:px-3 [&>li>a]:py-2.5 [&>li>a]:text-left [&>li>a]:text-base/7 [&>li>a]:font-semibold [&>li>a]:text-gray-900
            [&>li>a]:no-underline [&>li>a]:before:w-0 dark:[&>li>a]:text-white
            [&>li>a:hover]:bg-gray-50 [&>li>a:hover]:before:w-0 dark:[&>li>a:hover]:bg-white/5'
        />
      </div>
    </div>
  );
};

export default NavSidebarContent;
